import 'core-js/es/object';

import React from 'react';
import ReactDOM from 'react-dom';

import { warning, ErrorCodes } from './phase2/survey/app/warning';
import Survey from './phase2/survey';
import SurveyEmbedded from './embedded-type/survey';
import { EMBEDDED_POINT } from './phase2/survey/app/constants';

const el = document.getElementById('rexSurveyRoot');
if (!el) {
  warning(ErrorCodes.ERR_NO_ROOT_ELEMENT)();
}

let embeddedRoot = null;
let embedded = false;
if (!window.rexSurveyConfig) {
  warning(ErrorCodes.ERR_NO_CONFIG)();
} else {
  const config = window.rexSurveyConfig;
  if (!config.surveyId) {
    warning(ErrorCodes.ERR_NO_SURVEY_ID)();
  }
  // embedded
  if (config.embedded) {
    embedded = true;
    embeddedRoot = document.getElementById(EMBEDDED_POINT);
    if (!embeddedRoot) {
      // not found embedded root id
      // TODO: warning
      console.warn('config.embeddedIdName not found');
    }
  }
}

if (!embedded) {
  if (el && window.rexSurveyConfig) {
    ReactDOM.render(<Survey />, el);
  }
} else if (window.rexSurveyConfig && el && embeddedRoot) {
  // embedded component start
  SurveyEmbedded({ popup: el, embedded: embeddedRoot });
}



// WEBPACK FOOTER //
// ./src/index.js